module.exports = __webpack_public_path__ + "static/media/8OLA3.8e07eb73.jpg";